import { render, staticRenderFns } from "./AgreementPage.vue?vue&type=template&id=084dcf2a&"
import script from "./AgreementPage.vue?vue&type=script&lang=js&"
export * from "./AgreementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports